/* © 2014 - Copyright of Aetonix Systems Inc - All Rights Reserved. Patent pending.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Aetonix, June 19, 2014
 * For information or permission request, email info@aetonixsystems.com
 */

var Model = require("../types/Model.js");

/**
 * This model is used for tracking a person's aggregated read and unread notifications(call, conference, text, banner).
 * A notification contains all of the calls, conference, text and banners that a person has received
 * @type {Model}
 */

module.exports = Model({
	name: "usernotifications",
	init: init,
	triggers: triggers,
	listeners: listeners,

});

function triggers() {
	return {
		"clear": trigger_clear,
		"clear:all": trigger_clear_all,
	};
}

function listeners() {
	return {
		"readnotifications:updated": Model.makeExtender("read"),
		"unreadnotifications:updated": Model.makeExtender("unread"),
	};
}

function init() {
	this.push({
		read: [],
		unread: [],
	});
}

function trigger_clear(data) {
	var notification = data.from;
	this.api.notifications.clear(notification);
	this.emit("usermetrics:trigger:track", "mark notifications as read", {
		notification,
	});
}

function trigger_clear_all(){
	this.api.notifications.clearAll();
	this.emit("usermetrics:trigger:track", "mark all notifications as read");
}
